
<template>
    <div class="position-relative d-inline">
        <div @click.stop="toggleMenu(); dropdown = !dropdown" class=" position-relative cursor-pointer">
            <i class="material-symbols-rounded fsz-20 d-flex align-items-center options">notifications</i>
            <span v-if="dashStore.getUserNotifCount(notifNumber)"
                class="position-absolute  top-0 start-100  translate-middle badge rounded-pill-badge-sm bg-danger-600 ">
                {{ dashStore.getUserNotifCount(notifNumber) }}
            </span>
        </div>

        <OnClickOutside @trigger.stop="dropdownHandler" v-if="dropdown" class="dropdown-inner notification-panel">
            <div class="d-flex p-3 border-bottom justify-content-between align-items-center">
                <p>
                    Notifications
                    <span>({{ notifyStore.getIsNotRead }})</span>
                </p>
            </div>
            <ScrollPanel v-if="notifyStore.getUserNotification.length" style="width: 100%; height: 420px">
                <DetailsNotif v-for="item in notifyStore.getUserNotification" @click="dropdownHandler" :item="item">
                </DetailsNotif>
            </ScrollPanel>
            <div class="d-flex flex-column justify-content-center align-items-center bg-white rounded-2" v-else style="width: 100%; height: 320px">
                <div class="avatar avatar-icon avatar-xl bg-primary-25 large-size mx-auto mb-4">
                    <i class="material-symbols-rounded fsz-20 me-0 text-primary-600">notifications</i>
                </div>

                <p class=" text-center fsz-14" style="max-width: 562px;">
                    Aucune Notification pour le Moment
                </p>
            </div>
        </OnClickOutside>
    </div>
</template>

<script setup lang="ts">
import type { OnClickOutsideHandler } from '@vueuse/core'
import { OnClickOutside } from '@vueuse/components'
// stores
import { useDashboardStore } from "~/store/useDashboardStore";
import { useNotifyStore } from "~/store/useNotificationStore";

const notifyStore = useNotifyStore();
const dashStore = useDashboardStore();

const notifNumber = ref(false)
const dropdown = ref(false)
const toggleMenu = async () => {
    notifyStore.fetchNotification();
    notifNumber.value = true;  
};
const dropdownHandler: OnClickOutsideHandler = () => {
    dropdown.value = false
}

</script>

<style scoped lang="scss">
.dropdown-inner {
    background-color: white;
    position: absolute;
    right: 0 !important;
    top: 30px;
    z-index: 1030;
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
}
</style>
